/** 학습내용 끝의 연차시 표시 `(n/m)` */
const SESSION_SUFFIX_RE = /\s*\(\s*\d+\s*\/\s*\d+\s*\)\s*$/;

export function stripLearningSessionSuffix(text: string): string {
  return text.replace(SESSION_SUFFIX_RE, '').trim();
}

/**
 * 연속으로 같은 학습내용(연차시 표시 제외)이 이어지는 묶음마다 `(1/n)…(n/n)`으로 다시 매김.
 * 묶음이 1행이면 그대로 둔다. 반환: 바뀌는 행 인덱스 → 새 값.
 */
export function renumberLearningSessions(texts: readonly string[]): Map<number, string> {
  const changes = new Map<number, string>();
  let i = 0;
  while (i < texts.length) {
    const base = stripLearningSessionSuffix(texts[i] ?? '');
    if (!base) {
      i += 1;
      continue;
    }
    let j = i + 1;
    while (j < texts.length && stripLearningSessionSuffix(texts[j] ?? '') === base) j += 1;
    const count = j - i;
    if (count >= 2) {
      for (let k = i; k < j; k += 1) {
        const next = `${base} (${k - i + 1}/${count})`;
        if ((texts[k] ?? '').trim() !== next) changes.set(k, next);
      }
    }
    i = j;
  }
  return changes;
}
